import {createCommonAsyncThunk} from "../../../../newShared/utils/asyncThunk";
import {sendSupportMessage} from "../api/query";
import {SendSupportMessageMutationVariables, SendSupportMessageMutation} from "../../../../newShared/GQLTypes";

export const sendSupportMessageAction =
    createCommonAsyncThunk<SendSupportMessageMutationVariables, SendSupportMessageMutation['sendSupportMessage']>(
        'contactUs', 'sendSupportMessage', true, false, sendSupportMessage
    );